import Navbar from "../components/Navbar";

import '../css/home.css';
import Initiatives from "../components/Initiatives";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";

export default function Services() {
    return (
        <>
            <Navbar />

            <Initiatives title={"Meri Services"} />

            <Footer />
            <BackToTop />
        </>
    );
}
